import { render, staticRenderFns } from "./ResultBox.vue?vue&type=template&id=7ef6a599&scoped=true&"
import script from "./ResultBox.vue?vue&type=script&lang=js&"
export * from "./ResultBox.vue?vue&type=script&lang=js&"
import style0 from "./ResultBox.vue?vue&type=style&index=0&id=7ef6a599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef6a599",
  null
  
)

export default component.exports